import { bootstrapThemePlugins } from './theme-main/plugins.js';
import { ThemeRuntime } from './theme-main/runtime/theme-runtime.js';
import { createThemeModules } from './theme-main/modules/index.js';

const runtimeContext = bootstrapThemePlugins();
const runtime = new ThemeRuntime(createThemeModules(runtimeContext));

runtime.bootstrap();

window.JWThemeRuntime = runtime;
window.JWThemeApp = runtime;
